import { render, staticRenderFns } from "./dataCreatFormNew.vue?vue&type=template&id=2b661450&"
import script from "./dataCreatFormNew.vue?vue&type=script&lang=js&"
export * from "./dataCreatFormNew.vue?vue&type=script&lang=js&"
import style0 from "./dataCreatFormNew.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dataCreatFormNew.vue"
export default component.exports